import axios from 'axios'
import { showToast } from 'vant';

// create an axios instance
const service = axios.create({
  timeout: 5000 // request timeout
});
service.defaults.withCredentials = true;

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // Promise.reject(error)
    return Promise.reject(error);
  }
);

// Add a response interceptor
service.interceptors.response.use(
  response => {
    if (response.data.status === 200) {
      return response.data;
    } else {
      showToast(response.data.msg);
    }
  }, error => {
    // Do something with response error
    return Promise.reject(error);
  }
);

export default service;
